import { type VariantProps, cva } from 'class-variance-authority'
import type { HTMLAttributes } from 'react'
import { cn } from '#utils/utils.js'

const badgeVariants = cva(
  'focus:ring-ring inline-flex w-fit items-center rounded-full px-2 font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 select-none shrink-0 hover:bg-opacity-65 [&>[data-slot="icon"]]:mr-1',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground',
        secondary: 'bg-base-100 text-base-700',
        destructive: 'bg-rose-100 text-rose-800',
        warning: 'bg-warning-100 text-warning-800',
        outline: 'text-foreground border border-border',
        orange: 'bg-orange-100 text-orange-800',
        success: 'bg-success-100 text-success-800',
        indigo: 'bg-indigo-100 text-indigo-800',
        violet: 'bg-violet-100 text-violet-800',
        slate: 'bg-slate-100 text-slate-700',
        stone: 'bg-stone-100 text-stone-800',
        accent: 'bg-accent-100 text-accent-800',
        brand: 'bg-brand-100 text-brand-800'
      },
      size: {
        xs: 'h-4 text-xxs [&>[data-slot="icon"]]:size-2.5 ',
        sm: 'h-5 text-xs [&>[data-slot="icon"]]:size-3',
        default: 'h-6 text-sm [&>[data-slot="icon"]]:size-3.5'
      }
    },
    defaultVariants: {
      variant: 'default',
      size: 'default'
    }
  }
)

export interface BadgeProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = ({ className, variant, size, ...props }: BadgeProps) => {
  return (
    <div
      className={cn(badgeVariants({ variant, size }), className)}
      {...props}
    />
  )
}

export { Badge, badgeVariants }
